import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "../components/Dashboard/Header";
import Sidebar from "../components/Dashboard/Sidebar";
import Footer from "../components/Dashboard/Footer";
import Dashboard from "../Layouts/User/dashboard/Dashboard";
import Watchlist from "../Layouts/User/Watchlist/Watchlist";
import LedgerReport from "../Layouts/User/ledgerReport/LedgerReport";
import Order from "../Layouts/User/order/Order";
import BalanceStatement from "../Layouts/User/balanceStatement/BalanceStatement";
import PaymentHistory from "../Layouts/User/paymentHistory/PaymentHistory";
import News from "../Layouts/User/news/News";
import TradeStatement from "../Layouts/User/tradeStatement/TradeStatement";
import Portfolio from "../Layouts/User/portfolio/Portfolio";
import PrivacyPolicy from "../Layouts/User/privacyPolicy/PrivacyPolicy"
import Registeredbank from "../Layouts/User/registeredbank/Registeredbank"
import TermCondition from "../Layouts/User/termcondition/TermCondition";
 import ReferCode from "../Layouts/User/refercode/ReferCode";
 import OptionChain from "../Layouts/User/optionchain/OptionChain";
 import OptionChain1 from "../Layouts/User/optionchain/OptionChain1";
import KycDocument from "../Layouts/User/kycdocument/kycdocument";
import Favoriteslist from "../Layouts/User/Favrorites/Favoriteslist";
import Researchs from "../Layouts/User/research/Researchs";
const UserRoutes = () => {
  return (
    <div id="main-wrapper" className={`wallet-open show `}>
      <Header />
      <Sidebar />
      <div className="content-body">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/watchlist" element={<Watchlist />} />
          <Route path="/orders" element={<Order />} />
          <Route path="/trade-statement" element={<TradeStatement />} />
          <Route path="/ledger-report" element={<LedgerReport />} />
          <Route path="/balance-statement" element={<BalanceStatement />} />
            <Route path="/bank-details" element={<Registeredbank />} />
          <Route path="/payment-history" element={<PaymentHistory />} />
          <Route path="/news" element={<News />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermCondition/>} />
           <Route path="/refer" element={<ReferCode/>} />
            <Route path="/option-chain" element={<OptionChain/>} />
              <Route path="/option-chain1" element={<OptionChain1/>} />
              <Route path="/kyc" element={<KycDocument/>} />
              <Route path ="/favorites" element={<Favoriteslist/>} />
              <Route path ="/research" element={<Researchs/>} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
};

export default UserRoutes;
